import React, { useState, useRef } from 'react';

const InfoTooltip = ({ description }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const iconRef = useRef(null);

  const showTooltip = () => {
    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      setTooltipPosition({
        top: rect.bottom + 6, // 6px below the icon
        left: rect.left + rect.width / 2,
      });
    }
    setIsVisible(true);
  };

  return (
    <div className="relative inline-block ml-1">
      <button
        ref={iconRef}
        className="text-gray-400 hover:text-gray-600 focus:outline-none"
        onMouseEnter={showTooltip}
        onMouseLeave={() => setIsVisible(false)}
        onClick={() => setIsVisible(!isVisible)}
        type="button"
      >
        <svg
          className="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </button>
      {isVisible && (
        <div
          className="fixed z-50 w-64 p-2 text-sm text-white bg-gray-800 rounded shadow-lg"
          style={{
            top: tooltipPosition.top,
            left: tooltipPosition.left,
            transform: 'translateX(-50%)',
          }}
        >
          {description}
        </div>
      )}
    </div>
  );
};

export default InfoTooltip;